import { Link, useNavigate } from "react-router-dom";
import FipayLogo from "../../assets/icons/fipaylogo.png";
import ArrowLeft from "../../assets/icons/arrow-left.png";
import { useState } from "react";
import {
  Typeofaccountcontainer,
  TypeOfAccountBackgroundImage,
  TypeOfAccountModal,
  HeaderContainer,
  TypeOfAccountTextContainer,
  TypeOfAccountInformation,
  TypeOfAccountCreateText,
  CardsContainer,
  TypeOfButtonsContainer,
  AlreadyHaveAccount,
  AlreadyText,
  BackContainer,
  GoBackText,
  LogText,
} from "./TypeOfAccountPage.styles";
import HeroLandingPage from "../../assets/icons/hero-landingPage.png";
import Card from "../../components/Card/Card.component";
import Personal from "../../assets/icons/Personal.png";
import CardLogo from "../../assets/icons/cardLogo.png";
import Buttons from "../../components/Button/button.component";
import { colors } from "../../theme/color";

const TypeOfAccount: React.FC = () => {
  const [selectedCard, setSelectedCard] = useState<"personal" | "business">(
    "personal"
  );
  const navigate = useNavigate();

  const handleCardClick = (cardType: "personal" | "business") => {
    console.log(cardType);
    setSelectedCard(cardType);
  };

  const handleProceed = () => {
    if (selectedCard === "personal") {
      navigate("/auth/signup/personal");
    } else {
      navigate("/auth/signup/business");
    }
  };

  const NavigateToLogin = () => {
    navigate("/auth/login");
  };

  return (
    <Typeofaccountcontainer>
      <TypeOfAccountBackgroundImage>
        <img src="/assets/icons/hero-landingPage.png" alt="Hero Landing Page" />
      </TypeOfAccountBackgroundImage>
      <HeaderContainer>
        <img src="/assets/icons/fipaylogo.png" alt="Fipay Logo" />
      </HeaderContainer>
      <BackContainer>
        <img alt={"go back"} src="/assets/svg/goBack.svg" />
        <GoBackText onClick={NavigateToLogin}>Go back</GoBackText>
      </BackContainer>
      <TypeOfAccountModal>
        <TypeOfAccountTextContainer>
          <TypeOfAccountInformation>
            What type of account would you like to create
          </TypeOfAccountInformation>
          <TypeOfAccountCreateText>
            Select the type of account you want to create
          </TypeOfAccountCreateText>
        </TypeOfAccountTextContainer>
        <CardsContainer>
          <Card
            icon="/assets/icons/Personal.png"
            header="Personal/Individual Account"
            text="For freelancer, personal business and sole traders"
            handleClick={() => handleCardClick("personal")}
            checked={selectedCard === "personal"}
          />
          <Card
            icon="/assets/icons/cardLogo.png"
            header="Business Account"
            text="For registered business with corporate account information"
            handleClick={() => handleCardClick("business")}
            checked={selectedCard === "business"}
          />
        </CardsContainer>
        <TypeOfButtonsContainer>
          <Buttons
            handleClick={handleProceed}
            label="Continue"
            width="83%"
            color={colors.ButtonBackgroundColors.primaryMediumHoverButton}
            cursor="pointer"
            border="30px"
            height="48px"
          />
        </TypeOfButtonsContainer>
        <AlreadyHaveAccount>
          <AlreadyText>Already have an account? </AlreadyText>
          <LogText as={Link} to="/auth/login">
            {" "}
            Log in
          </LogText>
        </AlreadyHaveAccount>
      </TypeOfAccountModal>
    </Typeofaccountcontainer>
  );
};

export default TypeOfAccount;
